// @flow
'use strict';

import React from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';

import Icone from '../../../common/icone';
import CamposDocumentos from './campos_documentos';
import CamposItens from './campos_itens';
import CamposSituacoes from './campos_situacoes';

type ModalProps = {
  open : bool,
  suporte : bool,
  fechaModal : ()  => void,
  handleSubmit : () => void,
}

export const OPCAO_BOOLEANO = [
  { value: 'sim', label: 'Sim' },
  { value: 'nao', label: 'Não' },
];

export default function ModalBuscaEstruturada({ open, suporte, fechaModal, handleSubmit } : ModalProps) {
  return (
      <Modal show={ open } onHide={ fechaModal } dialogClassName="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Busca Avançada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={ handleSubmit }>
            <section className="busca-estruturada">
              <Row>
                <Col md={ 7 }>
                  <CamposDocumentos/>
                </Col>
                <Col md={ 5 }>
                  <CamposItens/>
                </Col>
              </Row>
              <CamposSituacoes suporte={ suporte }/>
            </section>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default" onClick={ fechaModal }>Fechar</Button>
          <Button bsStyle="primary" onClick={ handleSubmit }><Icone nome="search" estilo="fas">Buscar</Icone></Button>
        </Modal.Footer>
      </Modal>
  );
}
